import Image from "next/image";
import { Link, animateScroll as scroll } from "react-scroll";

//local imports
import classes from "@/styles/pricing/plan.module.css";
import { plan as p } from "@/utils/content";
import { planImg1 } from "@/utils/images";
import PlanFaqs from "./plan-faqs";
import PlanFeatures from "./plan-features";
import { Button, Row, Col } from "reactstrap";
import { SubscriptionPlan } from "@/@types/SubscriptionPlan";

type Props = {
  planData: SubscriptionPlan;
  allPlans: SubscriptionPlan[];
};

export default function PlanMain({ planData, allPlans }: Props) {
  const content = p.en;

  return (
    <div className={classes.container}>
      <section className="my-5 text-center container">
        <h4>{content.subscriptionPlan}</h4>
        <h1>{planData?.title}</h1>
        <div
          className={`d-flex justify-content-center align-items-center gap-5 mt-3 mb-3`}
        >
          <Link
            activeClass="active"
            to="price-section"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className={`${classes.navBtn} rounded-pill px-4`}
          >
            {content.price}
          </Link>
          <Link
            activeClass="active"
            to="core-features-section"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className={`${classes.navBtn} rounded-pill px-4`}
          >
            {content.core}
          </Link>
          <Link
            activeClass="active"
            to="advanced-features-section"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className={`${classes.navBtn} rounded-pill px-4`}
          >
            {content.advanced}
          </Link>
          <Link
            activeClass="active"
            to="faqs-section"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className={`${classes.navBtn} rounded-pill px-4`}
          >
            {content.faq}
          </Link>
        </div>
      </section>
      <section className="my-5 container" id="price-section">
        <Row>
          <Col xs={12} lg={6}>
            <h4>{content.priceInfo}</h4>
            <table className={classes.table}>
              <thead>
                <tr>
                  <th>{content.term}</th>
                  <th>{content.default}</th>
                  <th>{content.promo}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{content.yearly}</td>
                  <td>
                    {planData?.yearlyprice === 0
                      ? "Free"
                      : planData?.title === "Professional"
                      ? "$359.8*"
                      : planData?.title === ""
                      ? "$839.88"
                      : `$${planData?.yearlyprice}`}
                  </td>
                  <td>
                    {planData?.yearlyprice === 0
                      ? "Free"
                      : `$${planData?.yearlyprice}`}
                  </td>
                </tr>
                <tr>
                  <td>{content.monthly}</td>
                  <td>
                    {planData?.price?.amount === 0
                      ? "Free"
                      : planData?.title === "Professional"
                      ? "$29.99*"
                      : planData?.title === ""
                      ? "$69.99"
                      : `$${planData?.yearlyprice}`}
                  </td>
                  <td>
                    {planData?.price?.amount === 0
                      ? "Free"
                      : `$${planData?.price?.amount}`}
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
          <Col xs={12} lg={6}>
            <div className="text-center pt-3">
              <Image src={planImg1} alt={planImg1} height={100} width={100} />
              <p className="w-75 mx-auto mt-3">{content.para1}</p>
            </div>
          </Col>
        </Row>
      </section>
      {allPlans?.length > 0 && <PlanFeatures data={allPlans} />}
      <PlanFaqs />
    </div>
  );
}
